import React from 'react';
import PropTypes from 'prop-types';
import util from 'Utils/commonUtil';
// Components
import BasicButton from 'Components/common/BasicButton';

class Counter extends React.Component {
    state = {
        value: '',
    };
    isFocus = false;
    timer = null;
    reduceBtnDisabled = false;
    plusBtnDisabled = false;

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.defalutValue !== this.props.defalutValue) {
            this.checkBtnDisabled(this.props.defalutValue);
            this.setState({value: this.props.defalutValue});
        }
        if (prevState.value !== this.state.value) {
            this.checkBtnDisabled(this.state.value);

            if (util.isFunction(this.props.inputValid)) {
                this.props.inputValid(this.state.value);
            }
        }
    }

    componentWillMount() {
        if (this.state.value === '') {
            this.checkBtnDisabled(this.props.defalutValue);
            this.setState({value: this.props.defalutValue});
        }
    }

    /**
     * Update value.
     */
    onChange = (ev) => {
        let value = ev.target.value.replace(/([^0-9]*)/g, '');
        // const { options } = this.props;

        if (typeof this.props.currentSkuIndex !== 'undefined') {
            this.props.inputValid(value, this.props.currentSkuIndex);
        }
        this.setState({value});
    };

    onFocus = () => {
        if (util.isFunction(this.props.onFocus)) {
            this.props.onFocus();
        }
    };

    onBlur = () => {
        const {value} = this.state;
        const {options} = this.props;

        if (util.isNumber(options.min) && options.min > value) {
            this.setState({value: options.min});
        }
        if (util.isNumber(options.max) && options.max < value) {
            this.setState({value: options.max});
        }

        if (value === '' || value === null || value === undefined) {
            this.setState({value: options.min});
        }

        if (util.isFunction(this.props.onBlur)) {
            this.props.onBlur();
        }
    };

    reduce = () => {
        let value = this.state.value;
        value = --value;

        this.setState({value});

        // Run props inputValid.
        if (util.isFunction(this.props.inputValid)) {
            if (typeof this.props.currentSkuIndex === 'undefined') {
                if (
                    typeof this.props.cartFlag !== 'undefined' &&
                    this.props.cartFlag
                ) {
                    this.props.inputValid(value, 'reduce');
                } else {
                    this.props.inputValid(value);
                }
            } else {
                this.props.inputValid(value, this.props.currentSkuIndex);
            }
        }
    };

    plus = () => {
        let value = this.state.value;
        value = ++value;

        this.setState({value});

        // Run props inputValid.
        if (util.isFunction(this.props.inputValid)) {
            if (typeof this.props.currentSkuIndex === 'undefined') {
                if (
                    typeof this.props.cartFlag !== 'undefined' &&
                    this.props.cartFlag
                ) {
                    this.props.inputValid(value, 'plus');
                } else {
                    this.props.inputValid(value);
                }
            } else {
                this.props.inputValid(value, this.props.currentSkuIndex);
            }
        }
    };

    checkBtnDisabled = (value) => {
        let options = this.props.options || {};

        if (util.isNumber(options.min) && options.min >= value) {
            this.reduceBtnDisabled = true;
            value = options.min;
        } else {
            this.reduceBtnDisabled = false;
        }
        if (util.isNumber(options.max) && options.max <= value) {
            this.plusBtnDisabled = true;
            value = options.max;
        } else {
            this.plusBtnDisabled = false;
        }
    };

    render() {
        const {testid} = this.props;
        const options = this.props.options || {};
        let reduceBtnDisabled = util.isBoolean(options.reduceBtnDisabled)
            ? options.reduceBtnDisabled
            : this.reduceBtnDisabled;
        let plusBtnDisabled = util.isBoolean(options.plusBtnDisabled)
            ? options.plusBtnDisabled
            : this.plusBtnDisabled;

        console.log('Counter testid', testid);

        return (
            <div className="counter-box">
                <BasicButton
                    className="reduce-btn"
                    type="default"
                    disabled={reduceBtnDisabled}
                    testid={testid ? `${testid}-reduce-btn` : ''}
                    onClickOfSingleTap={this.reduce}>
                    -
                </BasicButton>
                <input
                    ref="input"
                    className="input"
                    type="text"
                    value={this.state.value}
                    testid={testid ? `${testid}-input` : ''}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onChange={this.onChange}
                />
                <BasicButton
                    className="plus-btn"
                    type="default"
                    disabled={plusBtnDisabled}
                    testid={testid ? `${testid}-plus-btn` : ''}
                    onClickOfSingleTap={this.plus}>
                    +
                </BasicButton>
            </div>
        );
    }
}

Counter.propTypes = {
    inputValid: PropTypes.func.isRequired,
    options: PropTypes.object,
};

export default Counter;
